// react
import { ReactNode } from 'react';

// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import MenuBookIcon from '@mui/icons-material/MenuBook';

// material ui
import { Box, Button, Stack } from '@mui/material';

interface FaqServiceSectionWrapperProps {
  title: string;
  icon?: ReactNode;
  children: ReactNode;
  manualLink?: string;
}

const FaqServiceSectionWrapper = ({
  children,
  manualLink,
}: FaqServiceSectionWrapperProps) => {
  const { t } = useTranslation('support');

  return (
    <Box width="100%" sx={{ bgcolor: 'transparent' }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        width="100%"
        mb={2}
      >
        {manualLink && (
          <Button
            component="a"
            variant="outlined"
            href={manualLink}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            startIcon={<MenuBookIcon />}
            sx={{ position: 'absolute', right: 0 }}
          >
            {t('manual')}
          </Button>
        )}
      </Box>
      <Stack gap={1}>{children}</Stack>
    </Box>
  );
};

export default FaqServiceSectionWrapper;
